import moment from 'moment'
import { LOCATION_CHANGE } from 'connected-react-router'

import { addUniqueArray, getReducerErrorMessage } from 'src/utils/helpers'

const initialState = {
  loading: false,
  // This will make it reload new documents
  loaded: false,
  loadingPoliciesDetails: false,
  policiesDetails: [],
  loadingPolicyDetails: false,
  policyDetails: null,
  documents: [],
  relatedDocuments: [],
  addedToWallet: [],
  document: null,
  policy: null,
  timeAdded: null,
  isSlipCreateInProgress: false,
  slipCreateResponse: {},
  relatedDocumentsPolicy: null,
  visitedAllPolicies: false,
}

export default function(state = initialState, action = {}) {
  switch (action.type) {
    // TODO: PAT-2250 This doesn't work in widget
    case LOCATION_CHANGE: {
      let newState = { ...state }

      const path = action.payload.location.pathname

      // Clear document details when navigated away from documents pages
      if (!path.includes('document')) {
        newState.document = initialState.document
      }

      // Clear policy details when navigated away from "full view" page
      if (!(path === '/documents/policy-summary' || path === '/documents/create-slip')) {
        newState.policyDetails = initialState.policyDetails
        newState.policy = initialState.policy
      }

      return newState
    }

    case 'GET_DOCUMENTS': {
      return {
        ...state,
        loading: true,
      }
    }

    case 'GET_DOCUMENTS_COMMIT': {
      return {
        ...state,
        loading: false,
        loaded: true,
        documents: action.payload.documents,
        timeAdded: moment(),
      }
    }

    case 'GET_DOCUMENTS_ROLLBACK': {
      return {
        ...state,
        loading: initialState.loading,
        loaded: initialState.loaded,
        documents: initialState.documents,
        timeAdded: initialState.timeAdded,
      }
    }

    case 'GET_RELATED_DOCUMENTS': {
      return {
        ...state,
        loading: true,
        loaded: false,
      }
    }

    case 'GET_RELATED_DOCUMENTS_COMMIT': {
      return {
        ...state,
        loading: false,
        loaded: true,
        relatedDocuments: action.payload.documents,
        timeAdded: moment(),
      }
    }

    case 'GET_RELATED_DOCUMENTS_ROLLBACK': {
      return {
        ...state,
        loading: initialState.loading,
        loaded: initialState.loaded,
        relatedDocuments: initialState.relatedDocuments,
        timeAdded: initialState.timeAdded,
      }
    }

    case 'CLEAR_DOCUMENTS': {
      const { ...initialStateRest } = initialState

      return {
        ...initialStateRest,
        // Preserve this state
        addedToWallet: state.addedToWallet,
      }
    }

    case 'SET_DOCUMENT': {
      return {
        ...state,
        document: action.payload.document,
      }
    }

    case 'CLEAR_DOCUMENT': {
      return {
        ...state,
        document: initialState.document,
      }
    }

    case 'CLEAR_DOCUMENT_FETCH_TIMESTAMP': {
      return {
        ...state,
        timeAdded: initialState.timeAdded,
      }
    }

    case 'SET_POLICY': {
      return {
        ...state,
        policy: action.payload.policy,
      }
    }

    case 'SET_RELATED_DOCUMENTS_POLICY': {
      return {
        ...state,
        relatedDocumentsPolicy: action.payload.policy,
      }
    }

    case 'SET_HISTORY_ALL_POLICY': {
      return {
        ...state,
        visitedAllPolicies: action.payload.visited,
      }
    }

    case 'CLEAR_POLICY': {
      return {
        ...state,
        policyDetails: initialState.policyDetails,
        policy: initialState.policy,
      }
    }

    // TODO: Add "clear" action...

    case 'GET_POLICIES_DETAILS': {
      return {
        ...state,
        loadingPoliciesDetails: true,
      }
    }

    case 'GET_POLICIES_DETAILS_COMMIT': {
      return {
        ...state,
        loadingPoliciesDetails: false,
        policiesDetails: action.payload,
      }
    }

    case 'GET_POLICIES_DETAILS_ROLLBACK': {
      return {
        ...state,
        loadingPoliciesDetails: false,
        policiesDetails: initialState.policiesDetails,
      }
    }

    case 'GET_POLICY_DETAILS': {
      return {
        ...state,
        loadingPolicyDetails: true,
      }
    }

    case 'GET_POLICY_DETAILS_COMMIT': {
      return {
        ...state,
        loadingPolicyDetails: false,
        policyDetails: action.payload,
      }
    }

    case 'GET_POLICY_DETAILS_ROLLBACK': {
      return {
        ...state,
        loadingPolicyDetails: false,
        policyDetails: initialState.policyDetails,
      }
    }

    case 'SET_ADDED_TO_WALLET': {
      return {
        ...state,
        // Add to array only if not already added
        addedToWallet: addUniqueArray(state.addedToWallet, action.payload.documentId),
      }
    }

    case 'DOCUMENTS_SLIP_CREATE': {
      return {
        ...state,
        isSlipCreateInProgress: true,
        slipCreateResponse: {},
      }
    }
    case 'DOCUMENTS_SLIP_CREATE_COMMIT': {
      return {
        ...state,
        isSlipCreateInProgress: false,
        slipCreateResponse: {
          success: true,
          payload: action.payload,
        },
      }
    }
    case 'DOCUMENTS_SLIP_CREATE_ROLLBACK': {
      return {
        ...state,
        isSlipCreateInProgress: false,
        slipCreateResponse: {
          success: false,
          message: getReducerErrorMessage(action),
        },
      }
    }

    default: {
      return state
    }
  }
}
